@import '~style-sheet-helpers/core.less';

.summary-bar {
  margin: 20px auto;
}

.container {
  display: flex;
}

.chart-section {
  width: 50%;
  margin: 20px;
}

.customers-by-day-graph {
  position: relative;
  margin-top: 20px;
}

.title-with-icon {
  margin-right: 4px;
}
